import slickLogo from 'assets/images/logos/slick-logo-text-white.png';
import Icon from 'components/generic/Icon.component';
import S from 'constants/string.const';
import { useTranslation } from 'providers/GILT.provider';

import CN from './MarketingContent.module.scss';

const Header = () => {
  const { t } = useTranslation();
  return (
    <div data-bem="MarketingContent__header">
      <img src={slickLogo} alt="Slick" className={CN.logo} />
      <section className={CN.header}>
        <p className={CN.eyebrow}>{t('register.marketing.eyebrow')}</p>
        <h1 className={CN.headline}>
          <span className={CN.headlineAccent}>{t('register.marketing.headlineProduct')}</span>
          {S.space}
          {t('register.marketing.headlineSuffix')}
        </h1>
        <p className={CN.subHeadline}>
          {t('register.marketing.subHeadline.part1')}
          {S.space}
          {S.dot}
          {S.space}
          {t('register.marketing.subHeadline.part2')}
        </p>
      </section>
    </div>
  );
};

const Bullets = () => {
  const { t } = useTranslation();
  return (
    <ul data-bem="MarketingContent__bullets" className={CN.bullets}>
      <li>
        <Icon variant="tickWhite" width="lg" />
        <span>
          <span className={CN.bulletAccent}>{t('register.marketing.bullet1.part1')}</span>
          {S.space}
          {t('register.marketing.bullet1.part2')}
        </span>
      </li>
      <li>
        <Icon variant="tickWhite" width="lg" />
        <span>
          <span className={CN.bulletAccent}>{t('register.marketing.bullet2.part1')}</span>
          {S.space}
          {t('register.marketing.bullet2.part2')}
        </span>
      </li>
      <li>
        <Icon variant="tickWhite" width="lg" />
        <span>
          <span className={CN.bulletAccent}>{t('register.marketing.bullet3.part1')}</span>
          {S.space}
          {t('register.marketing.bullet3.part2')}
        </span>
      </li>
    </ul>
  );
};

const MarketingContent = () => (
  <div data-bem="MarketingContent" className={CN.layout}>
    <Header />
    <Bullets />
  </div>
);

MarketingContent.Header = Header;
MarketingContent.Bullets = Bullets;

export { MarketingContent };
